import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

let navFn: (path: string, opts?: { replace?: boolean }) => void = () => {
  throw new Error('Navigator not set yet');
};

function setNavigator(fn: typeof navFn) {
  navFn = fn;
}

export function navigate(path: string, opts?: { replace?: boolean }) {
  navFn(path, opts);
}

export default function MyNavigator() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator((path, opts) => navigate(path, { replace: !!opts?.replace }));
  }, [navigate]);

  return null;
}
